import React, { useEffect, useState, useContext } from "react";
import { Box, Typography, Button, CircularProgress } from "@mui/material";
import MonthTarget from "../components/MonthlyTarget/MonthTarget";
import ScanIcon from "../assests/images/scanIcon.svg";
import Dotcode from "../assests/images/dotcodeScan.svg";
import i18n from "../i18n";
import { AuthContext } from "../context/AuthContext";
import { translation_en } from "../translations/translation_en";
import { translation_hi } from "../translations/translation_hi";
import { useNavigate } from "react-router-dom";

type MonthlyTaskProps = {
  questData?: any;
  monthlyData?: any;
  token?: string;
  taskId?: string | number | null;
  month?: string | undefined;
  year?: number | undefined;
  setMonth?: (m?: string) => void;
  setYear?: (y?: number) => void;
  taskTitle?: string;
};

const MonthlyTask: React.FC<MonthlyTaskProps> = ({
  questData,
  monthlyData,
  token = "",
  taskId,
  month,
  year,
  setMonth,
  setYear,
  taskTitle
}) => {
  const authContext = useContext(AuthContext);
  const tokenFallback = token || (localStorage.getItem("x-auth-v1") || "").toString();
  const navigate = useNavigate();
  const contactId =
    (authContext as any)?.user?.ContactId ||
    (() => {
      try {
        const payload = JSON.parse(atob((tokenFallback || "").split(".")[1] || "{}"));
        return payload?.User?.ContactId || null;
      } catch {
        return null;
      }
    })();

  const [loading, setLoading] = useState(false);
  const [taskData, setTaskData] = useState<any>(monthlyData?.data?.[0] ?? null);
  const [taskUrl, setTaskUrl] = useState<string | null>(null);

  useEffect(() => {
    if (monthlyData) {
      setTaskData(monthlyData?.data?.[0] ?? monthlyData);
    }
  }, [monthlyData]);
   
   
     // Event listener for messages from iframe
    useEffect(() => {
  const handleMessage = (event: MessageEvent) => {
    console.log("event_coming here", event);

    if (event.data.type === "redirecttollp") {
      const encryptedTaskId = window.btoa(questData.data.task_id || questData.data.taskId);
      console.log(encryptedTaskId, "Taskkkkkid");

      // Redirect using window.location.href
      window.location.href = `/tasks/${encryptedTaskId}`;
    }
  };

  // Add event listener
  window.addEventListener("message", handleMessage);

  // Cleanup
  return () => window.removeEventListener("message", handleMessage);
}, []);


// const langKey = (localStorage.getItem("LANGUAGELOCALEKEY") || i18n.language || "en_IN").toString();
const langKey = localStorage.getItem("LANGUAGELOCALEKEY") || "en_IN";
const translations = langKey.startsWith("hi") ? translation_hi : translation_en;

// safe access (guard against missing keys)
const monthlynote =
  translations?.taskdetaitls?.dot_code_scanning?.monthly_note ??
  "Please click on the button below to scan up to 50 packs";

const monthlyButtonText =
  translations?.taskdetaitls?.dot_code_scanning?.monthly_submit ?? "Scan Pack To Earn Points";
// -------------------------

const monthlyins =  translations?.taskdetaitls?.dot_code_scanning?.monthly_ins ?? "Instruction"
  const generateUrl = async (task_id: number, publish_id: number) => {
    const requestOptions: RequestInit = {
      method: "POST",
      body: new FormData(),
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_WSA_API_URL}/wsa/api/auth/generate-token?secret_key=${process.env.REACT_APP_WSA_KEY}`,
        requestOptions
      );
      const result = await response.json();

      if (result && result.auth_token) {
        const url = `${process.env.REACT_APP_WSA_STATIC_URL}/wsa/app?languageId=${langKey.startsWith("hi") ? 2 : 1
        }&token=${result.auth_token}&published_id=${publish_id}&multiscan=${Number(
          taskData?.is_multiscan
        ) ? 1 : 0}`;
        setTaskUrl(url);
      } else {
        throw new Error("Failed to get token");
      }
    } catch (error) {
      console.error("Failed to generate token/url:", error);
      setLoading(false);
      alert("Failed to open task. Please try again later.");
    }
  };

  const handleScanClick = async () => {
    if (!taskData) {
      alert("No task data available!");
      return;
    }

    setLoading(true);
    const { task_id, published_id } = taskData;
    await generateUrl(task_id, published_id);
  };

  if (taskUrl) {
    return (
      <>
        {loading && <div className="loader">Loading...</div>}
        <iframe
          src={taskUrl}
          allow="camera; microphone"
          onLoad={() => setLoading(false)}
          style={{
            width: "100vw",
            minHeight: "100vh",
            display: loading ? "none" : "block",
            border: "none",
          }}
          title="Monthly Task"
        />
      </>
    );
  }

  return (
    <Box>
      {/* Pass token and accountId to MonthTarget so it doesn't need to call API */}
      <Box sx={{ padding: "0px" }}>
        <MonthTarget
          token={tokenFallback}
          accountId={contactId as string}
          initialMonthlyItem={taskData}
          monthlyPayload={monthlyData}
          month={month}
          year={year}
          setMonth={setMonth}
          setYear={setYear}
          taskTitle={taskTitle}
        />
      </Box>

      <Box sx={{ padding: "0px" }}>
        <Box
          sx={{
            borderRadius: "0px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
            background: "#fff",
            maxWidth: "100%",
            mx: "auto",
            mt: 3,
          }}
        >
          <Box sx={{ textAlign: "left", p: 2 }}>
            <Box display="flex" alignItems="left" mb={0} p={0}>
              <Box
                sx={{
                  background: "#FFE9E5",
                  width: 60,
                  height: 60,
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mb: 1,
                }}
              >
                <img src={ScanIcon} alt="scan Icon" />
              </Box>
              <Box sx={{ marginLeft: "20px" }}>
                <Typography
                  fontSize={12}
                  color="#7D7E7F"
                  fontWeight={600}
                  // textTransform="uppercase"
                >
                  {monthlyins}
                </Typography>
                <Typography
                  fontSize={14}
                  fontWeight={600}
                  color="#282829"
                  mt={0}
                  sx={{ maxWidth: 260, lineHeight: "20px" }}
                >
                  {/* Please click on the button below to scan up to 50 packs */}
                  {monthlynote}
                </Typography>
              </Box>
            </Box>

            <Button
              fullWidth
              variant="contained"
              disabled={loading}
              onClick={handleScanClick}
              sx={{
                mt: 1,
                backgroundColor: "#C8172F !important",
                color: "#fff",
                fontWeight: 500,
                borderRadius: "10px",
                textTransform: "none",
                boxShadow: "none",
                py: 1.4,
                fontSize: 14,
                "&:hover": { backgroundColor: "#C62800" },
              }}
              startIcon={<img src={Dotcode} alt="Dotcode" />}
            >
              {loading ? <CircularProgress size={20} sx={{ color: "#fff" }} /> :  monthlyButtonText}
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default MonthlyTask;
